var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCallSearchSegments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00004 17.0001C10.4059 17.0001 11.5455 15.8604 11.5455 14.4546C11.5455 13.0488 10.4059 11.9092 9.00004 11.9092C7.59423 11.9092 6.45459 13.0488 6.45459 14.4546C6.45459 15.8604 7.59423 17.0001 9.00004 17.0001Z",
    stroke: "#0079C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4546 6.09091C15.8604 6.09091 17.0001 4.95127 17.0001 3.54545C17.0001 2.13964 15.8604 1 14.4546 1C13.0488 1 11.9092 2.13964 11.9092 3.54545C11.9092 4.95127 13.0488 6.09091 14.4546 6.09091Z",
    stroke: "#0079C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54545 6.09091C4.95127 6.09091 6.09091 4.95127 6.09091 3.54545C6.09091 2.13964 4.95127 1 3.54545 1C2.13964 1 1 2.13964 1 3.54545C1 4.95127 2.13964 6.09091 3.54545 6.09091Z",
    stroke: "#0079C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54543 6.09082V6.81809C3.54423 7.10495 3.59984 7.38921 3.70906 7.65446C3.81828 7.91971 3.97895 8.16071 4.18179 8.36355C4.38463 8.56639 4.62563 8.72706 4.89088 8.83628C5.15613 8.9455 5.44039 9.00111 5.72725 8.99991H12.2727C12.5596 9.00111 12.8438 8.9455 13.1091 8.83628C13.3743 8.72706 13.6153 8.56639 13.8182 8.36355C14.021 8.16071 14.1817 7.91971 14.2909 7.65446C14.4001 7.38921 14.4557 7.10495 14.4545 6.81809V6.09082",
    stroke: "#0079C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9V11.9091",
    stroke: "#0079C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallSearchSegments);
export default __webpack_public_path__ + "static/media/CallSearchSegments.510075bcaf5207d5c9d63416a95fdc59.svg";
export { ForwardRef as ReactComponent };